module.exports = __webpack_public_path__ + "static/media/bg-about-us-s@3x.bd90bb6f.jpg";